import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'ambassadors',
		path: '/ambassadors',
		component: loadable(async () => import(/* webpackChunkName: "pages/ambassadors" */ './index'), {
			exportName: 'Ambassadors',
			fallback: Loading,
		}),
		// TEMPORARY — staff-only for the UI test that happens before the HubSpot API is wired up.
		//
		// Two things are knowingly inert behind this gate, and both are fine for staff:
		//   - the application form resolves without posting anywhere (see submitContractRequest)
		//   - the intro video is not uploaded yet, so it shows the poster and does not play
		//
		// DO NOT REMOVE THIS BLOCK until the HubSpot call has replaced `submitContractRequest`.
		// Un-gating first would show real applicants a thank-you while discarding their details.
		//
		// For the public launch: remove this block, flip `ssr.seo` to true below, and add page
		// metadata (see the note there) — all three together.
		//
		// Enforced by the server-side restrictedAccess middleware, so it holds for both SSR and
		// client routing. Unauthenticated visitors get the login page; signed-in non-staff get a
		// 403 (see checkRestrictedAccess -> 'forbidden').
		restrictedAccess: {
			authOnly: true,
			role: 'staff',
		},
		frame: {
			header: false,
			footer: true,
		},
		ssr: {
			enabled: true,
			// Deliberately false while the page is staff-only. `seo: false` both emits
			// <meta name="robots" content="noindex"> and adds /ambassadors to robots.txt Disallow.
			//
			// AT LAUNCH: flip to true together with removing `restrictedAccess` above. That alone
			// won't index well though — this page has no `pageTitle` or `pageMetadata`, so it would
			// fall back to the site-wide defaults with no page-specific title or description. Add
			// those (with `meta_tags` i18n strings) as part of the launch.
			seo: false,
		},
	},
];
